// extracted by mini-css-extract-plugin
export default {"pageErrorHandle":"index__pageErrorHandle___ESEhc","oncallUser":"index__oncallUser___hBbNM","oncallList":"index__oncallList___lsFVL"};